import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, persistentSingleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDzqo3zVzu176Xk1PgQUB6cV4rkEbw7Ir4",
  authDomain: "gymghost.firebaseapp.com",
  projectId: "gymghost",
  storageBucket: "gymghost.appspot.com",
  messagingSenderId: "189489217240",
  appId: "1:189489217240:web:abcdef123456"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);

const isMobileOrPWA = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  return isIOS || isStandalone;
};

let db;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: isMobileOrPWA() ? persistentSingleTabManager() : persistentMultipleTabManager(),
      cacheSizeBytes: 250 * 1024 * 1024 // 250MB cache to support extensive history
    })
  });
} catch (error) {
  console.warn("IndexedDB access blocked (Safari Private Browsing). Gracefully falling back to memory caching.");
  db = initializeFirestore(app, {}); 
}

export { db, storage, auth };

